<template>
  <div class="c-moniadd g-container">
    <moduler name="moniadd" title="新增iOS监控规则">
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">游戏</span>
        </Col>
        <Col span="12">
          <el-select v-model="monitor.gameIds" multiple filterable :popper-append-to-body="false" style="width: 320px">
            <el-option v-for="p in gameData" :key="p.id" :value="p.id" :label="p.name" :disabled="p.disabled"></el-option>
          </el-select>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">触发条件</span>
        </Col>
        <Col span="12">
          <condition
            v-model="monitor.monitorCondition"
            :data="ruleData"
            :max-cond="5"
            :satisfy="monitor.triggerType"
            :verify="formErr"
            @on-change="changeSatisfy"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">数据范围</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="monitor.dataRange" type="button">
            <Radio :label="1">今日实时</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">监测频率</span>
        </Col>
        <Col span="3" style="width: 100px">
          <RadioGroup v-model="monitor.monitorTime.key" vertical>
            <Radio label="quarter">每15分钟</Radio>
            <Radio label="half">每半小时</Radio>
            <Radio label="day">每天</Radio>
          </RadioGroup>
        </Col>
        <Col span="8" class="m-radio-select">
          <Select v-model="monitor.monitorTime.value" :disabled="monitor.monitorTime.key !== 'day'">
            <Option v-for="(time, index) of times" :key="index" :value="time">{{ time }}</Option>
          </Select>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">提醒类型</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="monitor.alertType" type="button">
            <Radio :label="1">仅钉钉</Radio>
            <Radio :label="2">仅邮件</Radio>
            <Radio :label="3">钉钉+邮件</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">提醒人员</span>
        </Col>
        <Col span="12">
          <el-select v-model="monitor.alertOpIds" multiple filterable :popper-append-to-body="false" style="width: 320px">
            <el-option v-for="p in operatorData" :key="p.id" :value="p.id" :label="p.name"></el-option>
          </el-select>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field row-item-must">规则名称</span>
        </Col>
        <Col span="12">
          <input-len v-model="monitor.ruleName" placeholder="最大100个字符，1个中文等于2个字符" :max="100" width="620" />
        </Col>
      </Row>
    </moduler>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="submit(0)">
            <span v-if="!loading">保存规则</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit(1)">
            <span v-if="!loading">新增规则</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { mul, div } from '@/common/js/api'
import { isArray, isEmpty, timeout, deepCopy } from '@/common/js/utils'
import validMixin from '../mixins/valid-mixin'
import times from '@/components/crontab/times'
import filteriOSes from '../data/filters_ios'

import Condition from '@/components/condition/condition-plus'
import InputLen from '@/components/input/input-len.vue'
import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'

import { adGames, getSysMember } from '@/api/common.model'
import { createiOSMonitor, getiOSMonitorDetail } from '@/api/manage.model'

export default {
  name: 'iOSMonitorAdd',
  mixins: [validMixin],
  components: {
    Condition,
    InputLen,
    Moduler,
    ErrorPop
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    }
  },
  data() {
    return {
      loading: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      ruleData: deepCopy(filteriOSes),
      times: times,
      monitor: {
        ruleId: this.$route.query.id, // 修改id
        ruleName: '',
        triggerType: 'all',
        monitorCondition: [],
        gameIds: [],
        alertOpIds: [], // 提醒人员
        alertType: 1, // 提醒规则
        monitorTime: {
          key: 'half',
          value: ''
        }, // 提醒时间
        dataRange: 1 // 数据统计周期
      },

      operatorData: [], // 系统人员
      gameData: [] // 游戏
    }
  },
  created() {
    this.proloadData()
    if (this.monitor.ruleId) this.getData()
  },
  methods: {
    getData() {
      // 加载动画
      this.$Spin.show()
      getiOSMonitorDetail({ ruleId: this.monitor.ruleId })
        .then((data) => {
          this.$Spin.hide()
          if (data) {
            const conditions = deepCopy(filteriOSes)
            const { ruleName, dataRange, alertType, monitorTime, ruleInfo, gameIds, alertOpIds, triggerType } = data
            let { key, value } = monitorTime
            value = value || ''
            this.monitor = Object.assign(this.monitor, {
              ruleName,
              dataRange,
              alertType,
              gameIds: gameIds.map((ret) => Number(ret)),
              alertOpIds: alertOpIds.map((ret) => Number(ret)),
              monitorTime: { key, value },
              monitorCondition: ruleInfo.map((ret) => {
                const cond = conditions.filter((met) => met.key === ret.key).pop()
                if (cond) ret = Object.assign({}, cond, ret)
                return ret
              }),
              triggerType
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    toFloat(key, obj, fixed) {
      if (isEmpty(obj[key])) return
      let val = parseFloat(obj[key])
      if (val < 0) val = 0
      else if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      }
      obj[key] = String(val)
    },
    // 改变监控规则
    changeSatisfy(val) {
      this.$set(this.monitor, 'triggerType', val)
    },
    customValid() {
      const err = []
      const condiValid = this.monitor.monitorCondition.some((ret) => isEmpty(ret.value)) // 触发条件
      if (condiValid) err.push({ feild: '触发条件', msg: '触发条件中的值验证不通过' })
      return err
    },
    proloadData() {
      this.$Spin.show()
      Promise.all([adGames({ platformId: 2, type: 1 }), getSysMember()]).then((data) => {
        this.$Spin.hide()
        const [gameData, operatorData] = data
        if (isArray(gameData)) {
          this.gameData = gameData.map((ret) => {
            ret.disabled = isEmpty(ret.game_address)
            return ret
          })
        }
        if (isArray(operatorData)) this.operatorData = operatorData
      })
    },
    valid() {
      const rules = [
        {
          name: 'monitor/ruleName',
          require: true,
          min: 2,
          max: 100,
          desc: '规则名称'
        },
        {
          name: 'monitor/gameIds',
          require: true,
          min: 1,
          desc: '游戏'
        },
        {
          name: 'monitor/alertOpIds',
          require: true,
          min: 1,
          desc: '提醒人员'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit(bool) {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      if (bool && this.monitor.ruleId) delete this.monitor.ruleId // 复制取消提交的id
      const params = Object.assign({}, this.monitor, {
        ruleInfo: this.monitor.monitorCondition.map((ret) => {
          return {
            key: ret.key,
            value: ret.value,
            expression: ret.expression
          }
        }),
        monitorTime: {
          key: this.monitor.monitorTime.key,
          value: this.monitor.monitorTime.value
        }
      })
      delete params.monitorCondition
      this.fetch(params)
    },
    fetch(params) {
      this.$Spin.show()
      this.loading = true
      createiOSMonitor(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 2,
            content: `${params.id ? '编辑' : '提交'}成功！2秒后自动跳转`
          })
          timeout(3000).then(() => {
            this.$router.back()
          })
        }
      })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.$router.back()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-moniadd {
  position: relative;
  overflow: auto;
  height: calc(100vh - 160px);

  .m-radio-select {
    height: 90px;
    display: flex;
    align-items: flex-end;

    .ivu-select {
      width: 180px;
    }
  }

  .row-item {
    align-items: flex-start;
  }

  .item-field {
    height: 32px;
    line-height: 32px;
  }

  .row-item-control {
    margin-top: 8px;
  }

  .row-item-label {
    text-align: right;
    padding: 8px;
  }

  /* 必填项 */
  .row-item-must {
    position: relative;
    z-index: 5;

    &:after {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 4px;
      position: absolute;
      top: 6px;
      right: 0;
      background-color: #f45858;
      border-radius: 3px;
    }
  }

  ::v-deep .el-select__input {
    margin-left: 7px;
  }

  ::v-deep .el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
    padding-left: 7px;
  }

  ::v-deep .ivu-btn {
    margin-left: 8px !important;
  }

  ::v-deep .c-add-btn {
    margin-left: 0 !important;
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;
    margin-bottom: 20px;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
